import { S3DownloadButton } from '@/components/S3DownloadButton'
import { AuditTrail } from '@/hooks/queries/useAuditTrails'
import { AppCsvUploadType, CoreCsvUploadType, UploadScope } from '@repo/csv'
import { UPLOAD_S3_EVENT_TYPES } from '@repo/utils'

type AuditTrailS3DownloadButtonProps = {
  auditTrail: AuditTrail
}

export function AuditTrailS3DownloadButton(props: AuditTrailS3DownloadButtonProps) {
  if (
    !UPLOAD_S3_EVENT_TYPES.includes(
      props.auditTrail.eventType as (typeof UPLOAD_S3_EVENT_TYPES)[number],
    )
  )
    return

  const uploadType = props.auditTrail.eventDetails.data['uploadType'] as
    | AppCsvUploadType
    | CoreCsvUploadType
  const fileName = props.auditTrail.eventDetails.data['fileName']
  const scope = props.auditTrail.eventDetails.data['scope'] as UploadScope

  return <S3DownloadButton uploadType={uploadType} fileName={fileName} scope={scope} />
}
